module.exports = __webpack_public_path__ + "static/media/datos.b977cc7b.svg";